export default (context, inject) => {
  const kwh = (value) => {
    const formatted = new Intl.NumberFormat('en-IE', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 3
    }).format(value);
    return `${formatted} cent`;
  };

  inject('kwh', kwh);
  context.$kwh = kwh;
};
